import { REDUCED_MOTION_QUERY } from 'styles/tokens';
import { useMediaQuery } from './useMediaQuery';

/** Whether the OS asks for reduced motion ("Reduce motion" / "Show animations" off), kept live. */
export const usePrefersReducedMotion = () => useMediaQuery(REDUCED_MOTION_QUERY);
